import { render } from "./ShowBhavaChart.vue?vue&type=template&id=59d05e7c&scoped=true"
import script from "./ShowBhavaChart.vue?vue&type=script&lang=js"
export * from "./ShowBhavaChart.vue?vue&type=script&lang=js"

import "./ShowBhavaChart.vue?vue&type=style&index=0&id=59d05e7c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d05e7c"]])

export default __exports__